import { Directive, HostListener, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { SidebarService } from "app/core/services/global/sidebar/sidebar.service";
import { Subscription } from "rxjs";

@Directive({
    selector: "[appSidebarButton]",
})
export class SidebarButtonDirective implements OnInit, OnDestroy {
    private _subscription: Subscription;
    constructor(private _renderer: Renderer2, private _sidebarService: SidebarService) {}

    @HostListener("click") onClick() {
        this._toggle();
    }

    ngOnInit(): void {
        this._subscription = this._sidebarService.enable$.subscribe((enable) => {
            enable ? this._open() : this._close();
        });
    }

    ngOnDestroy(): void {
        this._close();
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    }

    // Below this width the sidebar behaves as a mobile overlay ("sidebar-show"),
    // above it it is the persistent desktop sidebar ("sidebar-lg-show").
    private static readonly MOBILE_BREAKPOINT = "(max-width: 991.98px)";

    private get _isMobile(): boolean {
        return window.matchMedia(SidebarButtonDirective.MOBILE_BREAKPOINT).matches;
    }

    private _toggle() {
        // The burger toggles the visibility for the current breakpoint:
        // mobile -> overlay ("sidebar-show"), desktop -> persistent ("sidebar-lg-show").
        const clazz = this._isMobile ? "sidebar-show" : "sidebar-lg-show";
        if (document.body.classList.contains(clazz)) {
            this._renderer.removeClass(document.body, clazz);
        } else {
            this._renderer.addClass(document.body, clazz);
        }
    }

    private _open() {
        // Make the sidebar available: persistent on desktop, but keep it CLOSED by
        // default on mobile (no "sidebar-show") so it doesn't cover the content on load.
        this._renderer.addClass(document.body, "sidebar-lg-show");
    }

    private _close() {
        this._renderer.removeClass(document.body, "sidebar-lg-show");
        this._renderer.removeClass(document.body, "sidebar-show");
    }
}
